import React from "react";

import { Button } from "@chakra-ui/react";

export const CustomButton = ({
  type,
  mt,
  isLoading,
  isDisabled,
  onClick,
  label,
  height,
  width,
  buttonBlocked,
}) => {
  return (
    <Button
      h={!!height ? height : "42px"}
      w={!!width ? width : "auto"}
      mt={!!mt ? mt : "0px"}
      type={!!type ? type : "button"}
      color="#FFF"
      backgroundColor={isDisabled && buttonBlocked ? "gray.500" : "#169499"}
      fontWeight={700}
      fontSize={{ base: "13px", sm: "15px" }}
      lineHeight="21.6px"
      _hover={!buttonBlocked && { bg: "#169499" }}
      isLoading={!!isLoading}
      isDisabled={!!isDisabled}
      onClick={onClick}>
      {label}
    </Button>
  );
};
